<template>
  <div class="select-custom" :class="{ opened , 'select-custom--round': round}" v-click-outside="close">
    <div class="value" @click="open">
      <span>{{ valueOrPlaceholder }}</span>
      <div class="badge bg primary round" v-if="showCount && countActive">{{ countActive }}</div>
    </div>
    <div class="select-custom__list" :class="{ opened }">
      <label class="item" v-for="(item) in list" :key="item.id">
        <Checkbox :value="checkActive(item)" @set="handleSet(item)"/>
        <span>{{ item[labelBy] }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/form/Checkbox'
import outsize from '@/mixins/outsize'

export default {
  name: 'SelectCustom',
  components: {Checkbox},
  mixins: [outsize],
  model: {
    event: 'change',
    prop: 'active',
  },
  props: {
    name: String,
    list: Array,
    active: [Array, Object],
    displaySelected: Boolean,
    round: Boolean,
    isMultiple: {
      type: Boolean,
      default: true,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
    labelBy: {
      type: String,
      default: 'title'
    }
  },
  data: () => ({
    opened: false,
    init: false,
    lastActive: null,
  }),
  computed: {
    countActive() {
      return this.active?.filter((val) => val).length ?? 0
    },
    valueOrPlaceholder() {
      if (this.displaySelected && this.active && this.active.length) {
        const activeId = parseInt(this.active[0])
        return this.list.find((x) => x.id === activeId)?.[this.labelBy]
      }

      return this.name
    },
  },
  methods: {
    checkActive(item) {
      return this.active && this.active.includes(item.id);
    },
    handleSet(item) {
      this.lastActive = item.id;
      if(!this.isMultiple) {
        this.$emit('change', [item.id])
      }
      else {
        let currentIds = this.active ?? [];
        if(currentIds.includes(item.id)) {
          currentIds = currentIds.filter((id) => id !== item.id);
        }
        else {
          currentIds.push(item.id);
        }
        this.$emit('change', currentIds);
      }
    },
    close() {
      this.opened = false
    },
    open() {
      this.opened = true
    },
  },
}
</script>

<style lang="scss">
.select-custom {
  position: relative;
  background: #fff;
  min-width: 160px;

  &--round {
    .item {
      .checkbox {
        margin-right: 8px;

        .v {
          border-radius: 50% !important;
        }
      }
    }

    .value {
      height: 40px !important;
      border-radius: 10px !important;
    }

    .select-custom__list {
      border-radius: 10px !important;
    }
  }

  &__list {
    display: none;
    gap: 18px;
    padding: 53px 15px 25px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    border-radius: 5px;
    box-shadow: 0px 12px 21px rgba(204, 215, 230, 0.19);
    max-height: 517px;
    overflow-y: auto;

    .item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 0;

      .checkbox {
        width: 15px;
        height: 15px;
        margin-right: 8px;

        .v {
          border: 1px solid $dark;
          border-radius: 3px;
        }

        input:checked + .v {
          border: 1px solid $main;
        }
      }

      span {
        font-weight: 700;
        font-size: 12px;
        color: $darkGrey;
      }
    }

    &.opened {
      display: grid;
    }
  }

  .badge {
    z-index: 9;
    min-width: 0;
    margin-left: 7px;
  }

  .value {
    display: flex;
    align-items: center;
    height: 35px;
    background: url('~@/assets/icons/chevron-down.svg') no-repeat 94% center #fff;
    padding: 0 10px;
    padding-right: 24px;
    font-weight: 700;
    font-size: 12px;
    line-height: 147.5%;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    position: relative;
    z-index: 11;
  }

  &.opened {
    z-index: 12;
    .value {
      border: 1px solid transparent;
      background: url('~@/assets/icons/chevron-up.svg') no-repeat 94% center #fff;
    }
  }

  @include mobile {
    &.mobile-list {
      .value {
        font-size: 15px;
        border: none;
        background: none;
      }

      .select-custom__list {
        display: grid;
        gap: 24px;
        position: relative;
        padding: 18px 10px 25px;
        box-shadow: none;
        max-height: inherit;

        .item {
          .checkbox {
            width: 20px;
            height: 20px;
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
